import { createFileRoute } from '@tanstack/react-router';

import { TrialClassListPage } from '~features/classes/ui/trial-class-list-page';

const Component = () => {
  return <TrialClassListPage />;
};

export const Route = createFileRoute('/_auth/_layout/classes/trial-students')({
  component: Component,
});
